import React from 'react';
import AlumniHeroSection from '../components/AlumniComponents/AlumniHeroSection';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const AlumniPage = () => {
  return (
    <>
      <AlumniHeroSection />
    </>
  );
};

export default AlumniPage;